import { render, staticRenderFns } from "./NotesHRM.vue?vue&type=template&id=3b8aefe6&"
import script from "./NotesHRM.vue?vue&type=script&lang=js&"
export * from "./NotesHRM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports